import { createContext, useContext, useLayoutEffect } from "react";
import { useFormContext } from "../FormContext.js";
import { useFieldsetContext } from "./fieldSet/FieldSetContext.js";
const FieldContext = /*#__PURE__*/ createContext(void 0);
const FieldContextProvider = FieldContext?.Provider;
const useFieldContext = ()=>useContext(FieldContext);
const useSynchronizedProps = ({ status: statusProperty, size: sizeProperty, disabled: disabledProperty, readOnly: readOnlyProperty, required: requiredProperty, inputType })=>{
    const formContext = useFormContext();
    const fieldsetContext = useFieldsetContext();
    const fieldContext = useFieldContext();
    const disabled = disabledProperty ?? fieldsetContext?.disabled ?? formContext?.disabled;
    const readOnly = readOnlyProperty ?? fieldsetContext?.readOnly ?? formContext?.readOnly;
    const required = requiredProperty ?? fieldsetContext?.required ?? formContext?.required;
    const status = statusProperty ?? fieldsetContext?.status ?? formContext?.status;
    const size = sizeProperty ?? fieldsetContext?.size ?? formContext?.size;
    useLayoutEffect(()=>{
        fieldContext?.setDisabled(disabled);
        fieldContext?.setReadOnly(readOnly);
        fieldContext?.setRequired(required);
        fieldContext?.setStatus(status);
        fieldContext?.setSize(size);
        fieldContext?.setInputType(inputType);
    }, [
        fieldContext,
        disabled,
        readOnly,
        inputType,
        required,
        size,
        status
    ]);
    return {
        status,
        size,
        disabled,
        readOnly,
        required
    };
};
export { FieldContextProvider, useFieldContext, useSynchronizedProps };
